module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SOIA.09e0a3c9.png";